import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { inject } from '@angular/core';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Limpiar token y datos de sesión
        localStorage.clear();
        router.navigate(['/']); //auth/login
        snackBar.open('Sesión expirada. Por favor, inicie sesión nuevamente.', 'Cerrar', {
          duration: 3000,
        });
        // Redirigir al login
      }
      return throwError(() => error);
    }),
  );
};
